module.exports = __webpack_public_path__ + "static/img/avatar48px_gly@2x.59a3cb5b.png";